import React from "react";
import LayoutProjects from "./LayoutProjects";
import EshopImg from "../../img/png/eshop-img.png";
import EshopVideo from "../../img/mp4/eshop-video.mp4";

export default function Personal() {
  let language = localStorage.getItem("language");

  return (
    <LayoutProjects
      title={language === "english" ? "ESHOP SPA" : "TIENDA VIRTUAL"}
      features={
        language === "english"
          ? [
              "Login",
              "Cart items",
              "CRUD Items",
              "Profits",
              "SPA",
              "Buy window",
            ]
          : [
              "Inicio de sesión",
              "Productos",
              "Administrar items",
              "Ganancias",
              "Aplicación de una página",
              "Ventana de compra",
            ]
      }
      img={EshopImg}
      description={
        language === "english"
          ? "Web page created trying to learn about SPA and fullstack applications, i used Ant design as frontend library, this application can be deployed on a real production."
          : "Página web creada intentando aprender acerca de las aplicaciones de una página y fullstack, usé Ant Design como libreria front end, esta aplicación puede ser usada y desplegada en un entorno real."
      }
      color="#fe2"
      textColor="#222"
      video={EshopVideo}
      tecno={["React", "MongoDB", "Express", "Node.js", "Antd"]}
      link="https://github.com/RAdvelopment"
    />
  );
}
